require('sass/brands/locations.jcpenney.com/directory/default.scss');
require('js/locationList-script.js');
